import { useState } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import { Search } from "@mui/icons-material";
import { InputAdornment } from "@mui/material";

import { MultipleSelectChip } from "components/MultipleSelectChip/MultipleSelectChip";
import KsprInput from "components/UI/input/KsprInput";
import { useDebounce } from "hooks/useDebounce";
import { getUserPermissions } from "slices/auth";
import { getSomStatus } from "slices/books/booksSelectors";

import styles from "./DataFilterGroup.module.css";

export const DataFilterGroup = ({ setSearchValue, selectedStatus, setSelectedStatus, disabled }) => {
	const { state } = useLocation();
	const somStatus = useSelector(getSomStatus);
	const userPermissions = useSelector(getUserPermissions);
	const debouncedSetSearchValue = useDebounce(setSearchValue);

	const [searchText, setSearchText] = useState(state?.somItemCode ?? "");

	const handleChange = (e) => {
		const newValue = e.target.value;
		setSearchText(newValue);
		debouncedSetSearchValue(newValue);
	};

	return (
		<div className={styles.container}>
			<KsprInput
				label="Поиск по коду и наименованию ресурса"
				size="small"
				disabled={disabled}
				value={searchText}
				onChange={handleChange}
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<Search />
						</InputAdornment>
					),
				}}
			/>
			{userPermissions.is_som_admin === true && (
				<MultipleSelectChip label="Статус" value={selectedStatus} setValue={setSelectedStatus} options={somStatus} />
			)}
		</div>
	);
};
